import { withRouteX } from '~/router';
import { lazy, Suspense } from 'react';

export default withRouteX({ name: 'tender-report' })(() => <Page />);

const Report = lazy(() => import('./Report'));

const Page = () => {
  return (
    <Suspense fallback={null}>
      <Report />
    </Suspense>
  );
};
